export default __webpack_public_path__ + "static/media/blog05.e7d4afc8.png";